/* NADAM product page — interactions. Plain JS, no dependencies; runs once however many sections include it. */
(function () {
  if (window.__nadamPage) return;
  window.__nadamPage = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var root = $('.nd');
    if (!root) return;

    // ---- scroll progress
    var bar = $('.nd-progress');
    if (bar) {
      var onScroll = function () {
        var h = document.documentElement;
        var p = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight);
        bar.style.width = (p * 100).toFixed(2) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // ---- reveal on scroll (+ staggered children)
    $$('[data-stagger]').forEach(function (g) {
      $$('[data-reveal]', g).forEach(function (el, i) { el.style.setProperty('--d', (i * 0.08).toFixed(2) + 's'); });
    });
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.dispatchEvent(new CustomEvent('nd:in'));
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' }) : null;
    $$('[data-reveal], .nd-inplace, [data-onview]').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });

    // ---- counters
    $$('[data-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var run = function () {
        if (reduce) { el.textContent = el.getAttribute('data-count-text') || target.toLocaleString(); return; }
        var t0 = performance.now();
        var step = function (t) {
          var k = Math.min(1, (t - t0) / 1600);
          var v = target * (1 - Math.pow(1 - k, 3));
          el.textContent = Math.round(v).toLocaleString() + (el.getAttribute('data-suffix') || '');
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      var host = el.closest('[data-reveal]') || el;
      if (io && host !== el) host.addEventListener('nd:in', run, { once: true }); else run();
    });

    // ---- hero: tilt + typing search
    var app = $('.nd-app');
    var win = app && $('.nd-app__win', app);
    if (app && win && !reduce && window.matchMedia('(min-width: 1001px)').matches) {
      app.addEventListener('mousemove', function (e) {
        var r = app.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        win.style.transform = 'rotateY(' + (-10 + x * 14).toFixed(2) + 'deg) rotateX(' + (6 - y * 10).toFixed(2) + 'deg)';
      });
      app.addEventListener('mouseleave', function () { win.style.transform = ''; });
    }
    var typed = $('[data-typing]');
    if (typed) {
      var lines = typed.getAttribute('data-typing').split('|');
      var li = 0, ci = 0, del = false;
      var tick = function () {
        var s = lines[li];
        typed.textContent = s.slice(0, ci);
        if (!del) { ci++; if (ci > s.length) { del = true; setTimeout(tick, 1800); return; } }
        else { ci -= 2; if (ci <= 0) { del = false; ci = 0; li = (li + 1) % lines.length; } }
        setTimeout(tick, del ? 22 : 55);
      };
      if (reduce) typed.textContent = lines[0]; else tick();
    }

    // ---- sticky buy bar (small screens): when the hero's buy box has scrolled away, until the final call to action
    var sticky = $('.nd-sticky'), heroBuy = $('.nd-hero .nd-buy'), ctaBuy = $('.nd-cta');
    if (sticky && heroBuy && 'IntersectionObserver' in window) {
      var heroVisible = true, ctaVisible = false;
      var upd = function () { sticky.classList.toggle('is-on', !heroVisible && !ctaVisible); };
      new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; upd(); }).observe(heroBuy);
      if (ctaBuy) new IntersectionObserver(function (e) { ctaVisible = e[0].isIntersecting; upd(); }).observe(ctaBuy);
    }

    // ---- marquee: duplicate the items so the loop is seamless
    $$('.nd-marquee__track').forEach(function (t) { t.innerHTML += t.innerHTML; });

    // ---- search demo: chips filter the grid
    $$('[data-search-demo]').forEach(function (demo) {
      var chips = $$('.nd-chip', demo), tiles = $$('.nd-tile', demo), q = $('.nd-demo__q', demo), count = $('.nd-demo__count b', demo);
      var update = function () {
        var on = chips.filter(function (c) { return c.classList.contains('on'); });
        var n = 0;
        tiles.forEach(function (t) {
          var tags = (t.getAttribute('data-tags') || '').split(' ');
          var ok = on.every(function (c) { return tags.indexOf(c.getAttribute('data-f')) >= 0; });
          t.classList.toggle('off', !ok);
          if (ok) n++;
        });
        if (count) count.textContent = n;
        if (q) q.innerHTML = on.length ? on.map(function (c) { return c.getAttribute('data-q'); }).join(' ') : '<span class="n">all files</span>';
      };
      chips.forEach(function (c) { c.addEventListener('click', function () { c.classList.toggle('on'); update(); }); });
      update();
      // a little self-demo the first time it scrolls into view
      if (io && !reduce) {
        demo.setAttribute('data-onview', '');
        io.observe(demo);
        demo.addEventListener('nd:in', function () {
          var seq = [0, 1, 2];
          seq.forEach(function (i, k) { setTimeout(function () { if (chips[i] && !chips[i].classList.contains('on')) { chips[i].classList.add('on'); update(); } }, 700 + k * 900); });
        }, { once: true });
      }
    });

    // ---- waveform player (visual only)
    $$('[data-player]').forEach(function (pl) {
      var c = $('canvas', pl), btn = $('.nd-play', pl), time = $('[data-time]', pl);
      if (!c) return;
      var ctx = c.getContext('2d'), playing = false, pos = 0, last = 0, dur = 214;
      var bars = [];
      for (var i = 0; i < 120; i++) bars.push(0.25 + 0.75 * Math.abs(Math.sin(i * 0.37) * Math.cos(i * 0.11) + Math.sin(i * 0.05) * 0.35));
      var draw = function () {
        var dpr = window.devicePixelRatio || 1, w = c.clientWidth, h = c.clientHeight;
        if (c.width !== w * dpr) { c.width = w * dpr; c.height = h * dpr; }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, w, h);
        var bw = w / bars.length;
        var g = ctx.createLinearGradient(0, 0, w, 0);
        g.addColorStop(0, '#4fd8ff'); g.addColorStop(1, '#b6f09c');
        for (var i = 0; i < bars.length; i++) {
          var x = i * bw, played = i / bars.length < pos;
          var amp = bars[i] * (playing && played ? 0.9 + 0.1 * Math.sin(last / 120 + i) : 1);
          var bh = Math.max(3, amp * h * 0.92);
          ctx.fillStyle = played ? g : 'rgba(255,255,255,0.16)';
          ctx.fillRect(x + 1, (h - bh) / 2, Math.max(1, bw - 2), bh);
        }
        if (time) {
          var s = Math.floor(pos * dur);
          time.textContent = Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2) + ' / 3:34';
        }
      };
      var loop = function (t) {
        if (!playing) return;
        if (last) pos = Math.min(1, pos + (t - last) / 1000 / dur * 8);   // plays at 8× so you can see it move
        last = t;
        if (pos >= 1) { pos = 0; }
        draw();
        requestAnimationFrame(loop);
      };
      btn && btn.addEventListener('click', function () {
        playing = !playing;
        (pl.querySelector('.nd-player') || pl).classList.toggle('is-playing', playing);
        btn.innerHTML = playing ? '<svg viewBox="0 0 24 24"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
        last = 0;
        if (playing) requestAnimationFrame(loop);
      });
      c.addEventListener('click', function (e) { var r = c.getBoundingClientRect(); pos = (e.clientX - r.left) / r.width; draw(); });
      window.addEventListener('resize', draw);
      draw();
    });

    // ---- "listening…": the AcoustID fingerprint demo
    $$('[data-finger]').forEach(function (f) {
      var bars = $$('.nd-finger__bars i', f), match = $('.nd-match', f.parentNode), btn = $('[data-replay]', f.parentNode), label = $('[data-finger-label]', f.parentNode);
      var run = function () {
        f.classList.add('is-run');
        if (match) match.classList.remove('is-on');
        if (label) label.textContent = 'Listening… making the fingerprint on this PC';
        var n = 0;
        var t = setInterval(function () {
          bars.forEach(function (b) { b.style.height = (15 + Math.random() * 85).toFixed(0) + '%'; });
          if (++n > 14) {
            clearInterval(t);
            f.classList.remove('is-run');
            if (label) label.textContent = 'Identified by sound';
            if (match) match.classList.add('is-on');
          }
        }, 130);
      };
      if (io) { f.setAttribute('data-onview', ''); io.observe(f); f.addEventListener('nd:in', run, { once: true }); } else run();
      btn && btn.addEventListener('click', run);
    });

    // ---- Discover: the mix sliders and moods
    $$('[data-discover]').forEach(function (d) {
      var ranges = $$('input[type=range]', d), segs = $$('.nd-mixbar i', d), legend = $$('[data-leg]', d), list = $('.nd-playlist', d);
      var split = function (len, w) {
        var sum = Math.max(1, w[0] + w[1] + w[2]);
        var r = w.map(function (x) { return Math.floor(len * x / sum); });
        var left = len - r[0] - r[1] - r[2];
        while (left-- > 0) { var m = w.indexOf(Math.max.apply(null, w)); r[m]++; }
        return r;
      };
      var update = function () {
        var w = ranges.map(function (r) { return +r.value; });
        ranges.forEach(function (r) { var o = r.parentNode.querySelector('output'); if (o) o.textContent = r.value; });
        var s = split(25, w);
        segs.forEach(function (g, i) { g.style.flexGrow = Math.max(0.0001, s[i]); });
        legend.forEach(function (l, i) { l.textContent = s[i]; });
      };
      ranges.forEach(function (r) { r.addEventListener('input', update); });
      update();
      var moods = {
        'rainy late-night drive': [['Midnight City', 'M83 · new to you'], ['Nightcall', 'Kavinsky · new to you'], ['Fading', 'Land After Time · from your library · recently played'], ['Roller Mobster', 'Carpenter Brut · new to you'], ['Teardrop', 'from your library · most played']],
        'focus': [['Weightless', 'from your library · most played'], ['An Ending (Ascent)', 'Brian Eno · new to you'], ['Night Owl', 'from your library · recently played'], ['Svefn-g-englar', 'Sigur Rós · new to you'], ['Avril 14th', 'from your library · never played']],
        'workout': [['Blinding Lights', 'The Weeknd · new to you'], ["Can't Hold Us", 'from your library · most played'], ['Turbo Killer', 'Carpenter Brut · new to you'], ['Lose Yourself', 'from your library · recently played'], ['Genesis', 'Justice · new to you']],
        'sunday morning coffee': [['Sunday Morning', 'from your library · most played'], ['Coffee', 'Sylvan Esso · new to you'], ['Banana Pancakes', 'from your library · recently played'], ['Pink + White', 'Frank Ocean · new to you'], ['Better Together', 'from your library · never played']],
      };
      $$('.nd-moods .nd-chip', d).forEach(function (c) {
        c.addEventListener('click', function () {
          $$('.nd-moods .nd-chip', d).forEach(function (x) { x.classList.remove('on'); });
          c.classList.add('on');
          var songs = moods[c.getAttribute('data-mood')] || [];
          if (list) list.innerHTML = songs.map(function (s, i) { return '<div style="animation-delay:' + (i * 0.07) + 's"><span>' + s[0] + '</span><small>' + s[1] + '</small></div>'; }).join('');
        });
      });
      var first = $('.nd-moods .nd-chip', d);
      if (first) first.click();
    });

    // ---- "what leaves my PC?"
    $$('[data-leaves]').forEach(function (l) {
      var t = $('.nd-toggle', l), p = $('.nd-leaves__panel', l);
      if (!t) return;
      var flip = function () { var on = t.classList.toggle('on'); p.classList.toggle('on', on); t.setAttribute('aria-expanded', on); };
      t.setAttribute('aria-expanded', 'false');
      t.addEventListener('click', flip);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    });

    // ---- save review: untick rows
    $$('[data-review]').forEach(function (r) {
      var rows = $$('.nd-review__row', r), btn = $('[data-review-count]', r);
      var upd = function () {
        var n = rows.filter(function (x) { return !x.classList.contains('off'); }).length;
        if (btn) btn.textContent = n === rows.length ? 'Save all ' + n + ' changes' : 'Save ' + n + ' ticked change' + (n === 1 ? '' : 's');
      };
      rows.forEach(function (row) {
        var b = $('.box', row);
        if (!b) return;
        var flip = function () { var off = row.classList.toggle('off'); b.setAttribute('aria-checked', !off); upd(); };
        b.addEventListener('click', flip);
        b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
      });
      upd();
    });

    // ---- download box: picking a tip updates the price line and the button
    $$('.nd-buy').forEach(function (box) {
      var radios = $$('[data-nd-variant]', box), price = $('[data-nd-price]', box), label = $('[data-nd-label]', box);
      var esc = function (t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; };
      var upd = function () {
        var r = radios.filter(function (x) { return x.checked; })[0];
        if (!r) return;
        var free = r.getAttribute('data-free') === '1', amt = r.getAttribute('data-price');
        if (price) price.innerHTML = free ? '<strong>Free</strong><span>Tips welcome, never required</span>' : '<strong>' + esc(amt) + '</strong><span>Thank you ☕</span>';
        if (label) label.textContent = free ? (box.getAttribute('data-free-label') || 'Download free') : 'Download + tip ' + amt;
      };
      radios.forEach(function (r) { r.addEventListener('change', upd); });
    });

    // ---- appearance: theme swatches
    $$('[data-themes]').forEach(function (t) {
      var box = $('.nd-themebox', t), name = $('[data-theme-name]', t);
      $$('.nd-swatch', t).forEach(function (s) {
        s.addEventListener('click', function () {
          $$('.nd-swatch', t).forEach(function (x) { x.classList.remove('on'); });
          s.classList.add('on');
          ['t1', 't2', 'ta', 'tb'].forEach(function (k) { box.style.setProperty('--' + k, s.getAttribute('data-' + k)); });
          if (name) name.textContent = s.getAttribute('data-desc') || '';
        });
      });
    });
  });
})();
